import Typography from "@vahak/core-ui/dist/components/Typography";
import COLORS from "@vahak/core-ui/dist/constants/colors";
import React from "react";

export interface OdcInfo {
    isOdc?: boolean;
    height?: number;
    breadth?: number;
    length?: number;
}

export interface OdcDetailsProps extends OdcInfo {}

const OdcDetails = ({ height = 0, length = 0, breadth = 0, isOdc }: OdcDetailsProps) => {
    if (!isOdc) {
        return null;
    }
    return (
        <div>
            <Typography size="xs" color={COLORS.GREY_500} weight="medium">
                ODC: {`${length}L x ${breadth}B x ${height}H (in mts)`}
            </Typography>
        </div>
    );
};

export default OdcDetails;
